<template >
  <div class="">
    <vs-popup
      type="filled"
      pazaryer
      title="Sipariş Detay"
      :active.sync="popupKartDetay"
    >
      <div id="invoice-page">
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button
              @click="yazdir()"
              class="mb-base mr-3"
              type="border"
              icon-pack="feather"
              icon="icon icon-download"
              >İndir/Yazdır</vs-button
            >
          </div>
        </div>
        <div id="printMe2">
          <vx-card id="invoice-container" style="padding: 25px">
            <!-- INVOICE METADATA -->
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td class="p-2">
                  <h1>{{ program }}</h1>
                </td>
                <td style="padding: 10px; text-align: right">
                  <h6>Sipariş Numarası</h6>
                  <p>{{ orderNumber }}</p>
                  <h6>Fatura Tarihi:</h6>
                  <p>{{ getNow() }}</p>
                </td>
              </tr>
            </table>

            <br />
            <table style="width: 100%" class="border-collapse">
              <tr>
                <td
                  style="
                    width: 50%;
                    padding-top: 25px;
                    text-align: center;
                    padding-bottom: 25px;
                    border: solid;
                  "
                >
                  <h6>Teslimat Adresi | {{ city }}</h6>
                </td>
                <td
                  style="
                    width: 50%;
                    padding-top: 25px;
                    text-align: center;
                    padding-bottom: 25px;
                    border: solid;
                  "
                >
                  <h6>Fatura Adresi | {{ city }}</h6>
                </td>
              </tr>
            </table>
            <br />
            <br />
            <table
              style="border-top: 1px solid grey; width: 100%"
              class="border-collapse"
            >
              <tr>
                <td>
                  <table style="width: 100% !important; text-align: center">
                    <tr>
                      <th
                        style="text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN RESMİ
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN KODU
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN ADI
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN FİYATI
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ADET
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        TUTAR
                      </th>
                    </tr>

                    <tr :key="indextr" v-for="(tr, indextr) in productDetail">
                      <td style="padding: 8px">
                        <vs-button
                          type="flat"
                          icon-pack="feather"
                          icon="icon-camera"
                          @click="imageShow(tr.barcode)"
                        ></vs-button>

                        <!--      <vs-button
                          type="flat"
                          icon-pack="feather"
                          icon="icon-camera"
                          id="popover-button-default"
                          @click="imageShow(tr.barcode)"
                        ></vs-button>
                        <b-popover
                          target="popover-button-default"
                          placement="top"
                          triggers="click"
                        >
                          <template #title>
                            <span>Default!</span>
                          </template>
                          <span
                            ><img :src="imageLink" style="width: 10%"
                          /></span>
                        </b-popover> -->
                      </td>

                      <td style="padding: 8px">
                        {{ tr.barcode }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.productName }}
                      </td>
                      <td style="padding: 8px">
                        {{ (tr.price).toFixed(2) }} TL
                      </td>
                      <td style="padding: 8px">{{ tr.quantity }} adet</td>
                      <td style="padding: 8px">{{ tr.amount }} TL</td>
                    </tr>

                    <tr>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          border-bottom: 1px solid grey;
                          border-left: 1px solid grey;
                          padding: 8px;
                        "
                      >
                        Toplam Tutar:
                      </td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;

                          border-bottom: 1px solid grey;
                          border-right: 1px solid grey;
                          padding: 8px;
                        "
                      >
                        {{ totalPrice.toFixed(2) }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <br />
            </table>
            <br />
            <table style="width: 100%" class="border-collapse">
              <tr>
                <v-barcode v-bind:value="barcodeValue" font-options="bold">
                  Can't generate the barcode
                </v-barcode>
              </tr>
              <tr>
                <td>
                  <h6>{{ cargoProviderName }} | {{ cargoTrackingNumber }}</h6>
                </td>
                <td></td>
              </tr>
            </table>

            <br />

            <!-- INVOICE FOOTER -->
          </vx-card>
        </div>
      
      </div>
      <b-modal
        ref="modal-resim"
        id="modal-primary"
        modal-class="modal-primary"
        size="sm"
        centered
        title=""
        hide-footer
        hide-header
      >
        <img :src="imageLink" style="width: 100%" />
      </b-modal>
      <vs-popup type="filled" :active.sync="popupimageshow">
        <img :src="imageLink" style="width: 100%"
      /></vs-popup>
    </vs-popup>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";
import VueBarcode from "vue-barcode";
import state from "../../../../store/state";
import Store from "../../../../store/store";
import { BButton, VBPopover, BPopover } from "bootstrap-vue";
export default {
  name: "SiparisDetayButton",
  props: [],

  data() {
    return {
      imageLink: "",
      popupimageshow: false,
      printMeVisible: false,
      city: "",
      barcodeValue: "",
      orderNumber: "",
      program: "",
      productDetail: [],

      quantityPrice: 0,
      grossAmount: 0,
      totalDiscount: 0,
      totalPrice: 0,

      telefon: 0,
      customerEmail: "",

      cargoProviderName: "",
      cargoTrackingNumber: "",
      discount: 0,

      mailTo: "",

      viewCheck: false,
      popupKartDetay: false,
    };
  },
  methods: {
    imageShow(sku) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { stokKodu: sku, token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.resimGoruntule(args, function (err, result) {
          if (result.resimGoruntuleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.resimGoruntuleResult);

          vm.imageLink = vm.veriler[0]["STOCKPICTURE"];
          vm.$refs["modal-resim"].show();
          //   vm.popupimageshow = true;
          // vm.$root.$emit('bv::show::popover', 'popover-button-default')

          /*  if (vm.veriler.length > 0) {
            vm.imageLink = vm.veriler[0]["STOCKPICTURE"];
            if (vm.imageLink.includes("http")) {
              vm.imageKontrol = true;
            } else vm.imageKontrol = false;
              
          }*/
        });
      });
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe2");
    },
    yazdir() {
      setTimeout(this.yazdirBekle, 5000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe2");
    },
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    printInvoice() {
      window.print();
    },

    siparisDetayCek(data, productValue) {
      var vm = this;
      vm.productDetail = [];
      vm.totalPrice = 0;
      vm.quantityPrice = 0;
      vm.popupKartDetay = true;

      vm.orderNumber = data.orderNumber;
      vm.program = data.invoiceFirstName;
      vm.cargoTrackingNumber = data.cargoTrackingNumber.trim();
      vm.barcodeValue = vm.cargoTrackingNumber;
      vm.city = data.City;
      console.log(productValue)


      /*    
            
      vm.grossAmount = productValue[0].grossAmount;
      vm.totalDiscount = productValue[0].totalDiscount;
      //  vm.totalPrice = productValue[0].TOTAL;
      vm.discount = productValue[0].discount;*/
      productValue.forEach((value, i) => {
        console.log(productValue[i].price)
        vm.productDetail.push({
          barcode: productValue[i].barcode,
          productCode: productValue[i].barcode,
          productName: productValue[i].stokAdi,
          quantity: productValue[i].quantity,
          price: productValue[i].price,
          amount: productValue[i].grossAmount,
        });
        if (vm.productDetail[i].Miktar > 1) {
          for (let index = 0; index < vm.productDetail[i].quantity; index++) {
            vm.quantityPrice += vm.productDetail[i].price;
          }
        } else {
          vm.quantityPrice = vm.productDetail[i].price;
        }
        vm.totalPrice += productValue[i].grossAmount;
      });
    },
  },
  directives: {
    "b-popover": VBPopover,
  },

  components: {
    BButton,
    BPopover,
    "v-barcode": VueBarcode,
  },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  },
  // mounted(){this.siparisDetay()}
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.popover.b-popover {
  z-index: 111111;
}
.con-vs-popup .vs-popup {
  width: 850px;
}
.vs-table--tbody-table {
  min-width: 0px;
}
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>

